import { z } from 'my-zod'

export const DamageWaiverCaseLifecycleStatusEnum = z
  .enum([
    'Draft',
    'Submitted',
    'InReview',
    'InAdvancedReview',
    'OrderingParts',
    'WaitingForPartsAndRepairs',
    'RepairComplete',
    'WaitingForPickupToBeScheduled',
    'PickupScheduled',
    'Closed'
  ])
  .setEnumLabels({
    Draft: 'Draft',
    Submitted: 'Submitted',
    InReview: 'In Review',
    InAdvancedReview: 'In Advanced Review',
    OrderingParts: 'Ordering Parts',
    WaitingForPartsAndRepairs: 'Waiting For Parts And Repairs',
    RepairComplete: 'Repair Complete',
    WaitingForPickupToBeScheduled: 'Waiting For Pickup To Be Scheduled',
    PickupScheduled: 'Pickup Scheduled',
    Closed: 'Closed'
  })

export type DamageWaiverCaseLifecycleStatusEnum = z.infer<typeof DamageWaiverCaseLifecycleStatusEnum>

export const DamageWaiverCaseSeverityTypeEnum = z
  .enum(['MinorDamage', 'SignificantDamage', 'MajorDamage', 'IncidentWithInjury'])
  .setEnumLabels({
    MinorDamage: 'Minor Damage',
    SignificantDamage: 'Significant Damage',
    MajorDamage: 'Major Damage',
    IncidentWithInjury: 'Incident with Injury'
  })

export const DamageWaiverCaseHazardCategoryTypeEnum = z
  .enum([
    'PotentialOccupantHazardProjectile',
    'CollisionImpact',
    'Fire',
    'Melt',
    'OccupantAreaBreach',
    'OccupantAreaHazardElectrical',
    'OccupantAreaHazardHeat',
    'OccupantRetentionMalfunction',
    'PotentialLossOfControl',
    'PotentialUnintendedFluidLoss',
    'PotentialUnintendedVehicleMotion',
    'RollOverTipOver',
    'Smoke',
    'Other'
  ])
  .setEnumLabels({
    PotentialOccupantHazardProjectile: 'Potential Occupant Hazard - Projectile',
    CollisionImpact: 'Collision / Impact',
    Fire: 'Fire',
    Melt: 'Melt',
    OccupantAreaBreach: 'Occupant Area Breach',
    OccupantAreaHazardElectrical: 'Occupant Area Hazard - Electrical',
    OccupantAreaHazardHeat: 'Occupant Area Hazard - Heat',
    OccupantRetentionMalfunction: 'Occupant Retention Malfunction',
    PotentialLossOfControl: 'Potential Loss of Control',
    PotentialUnintendedFluidLoss: 'Potential Unintended Fluid Loss',
    PotentialUnintendedVehicleMotion: 'Potential Unintended Vehicle Motion',
    RollOverTipOver: 'Roll Over / Tip Over',
    Smoke: 'Smoke',
    Other: 'Other'
  })

export const DamageWaiverCaseRespondingAuthoritiesTypeEnum = z
  .enum(['Police', 'Fire', 'Medical', 'ConservationOfficer', 'Other'])
  .setEnumLabels({
    Police: 'Police',
    Fire: 'Fire',
    Medical: 'Medical',
    ConservationOfficer: 'Conservation Officer',
    Other: 'Other'
  })

export const DamageWaiverCasePrimaryLeadTypeEnum = z
  .enum(['LegalReview', 'OutsideCaseReview', 'PSSFieldInvestigation', 'PolarisLegalCase'])
  .setEnumLabels({
    LegalReview: 'Legal Review',
    OutsideCaseReview: 'Outside Case Review',
    PSSFieldInvestigation: 'PSS Field Investigation',
    PolarisLegalCase: 'Polaris Legal Case'
  })

export const DamageWaiverCaseRepairStatusEnum = z
  .enum(['New', 'PartsOnBackOrder', 'ScheduledAtDealer', 'NotRepairingNA', 'Other'])
  .setEnumLabels({
    New: 'New',
    PartsOnBackOrder: 'Parts On Back Order',
    ScheduledAtDealer: 'Scheduled At Dealer',
    NotRepairingNA: 'Not Repairing / NA',
    Other: 'Other - See Notes'
  })

export const DamageWaiverCaseInvolvementTypeEnum = z
  .enum(['Driver', 'Passenger', 'ThirdPartyWitness', 'Police', 'Medical', 'Fire', 'ConservationOfficer'])
  .setEnumLabels({
    Driver: 'Driver',
    Passenger: 'Passenger',
    ThirdPartyWitness: 'Third Party/Witness',
    Police: 'Police',
    Medical: 'Medical',
    Fire: 'Fire',
    ConservationOfficer: 'Conservation Officer'
  })

export const DamageWaiverCaseDeductibleLevelTypeEnum = z.enum(['Standard', 'Premium'])

export const DamageWaiverCasePartOrderOrderStatusEnum = z.enum(['InProgress', 'Ordered', 'Shipped']).setEnumLabels({
  InProgress: 'In Progress',
  Ordered: 'Ordered',
  Shipped: 'Shipped'
})
